module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "basic-text-frame",
    attrs: {
      "id": "_idContainer055"
    }
  }, [_c('p', {
    staticClass: "structure-nxt",
    attrs: {
      "id": "calibre_pb_7"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("This book is dedicated to my mother, who has always been my biggest supporter, and told me to never give up on my dreams. I love you,"), _c('span'), _vm._v("Mom.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I would also like to thank all the wonderful participants who created postcards and submitted their manifestation stories to me. This book wouldn’t exist without you. You each are my"), _c('span'), _vm._v("inspiration.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Also, dedicated to Wayne Dyer, who has always been a huge influence in my life, and whom I had the pleasure of meeting a couple of years before he passed away. Below is his signature on a note where I wrote the words, Postcards to the Universe, when this book was still just a vision in my"), _c('span'), _vm._v("head.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph",
    attrs: {
      "id": "calibre_pb_8",
      "xml:lang": "en-GB"
    }
  }, [_c('img', {
    staticClass: "_idgenobjectattribute2",
    attrs: {
      "alt": "",
      "src": "OEBPS/image/_1_-_Dedication_Wayne_Dyer_Signature.jpg"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-65ed07ce","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/ebook_split_005.vue
// module id = 69
// module chunks = 0